import React, { useState, useEffect } from 'react';
import { HexColorPicker } from 'react-colorful';

const SHAPES = ['square', 'circle', 'triangle'];

export default function ShapeElementControlPanel({ element, onUpdate }) {
  const [selectedShape, setSelectedShape] = useState(element?.shape || 'square');
  const [color, setColor] = useState(element?.style?.fill || '#ff0000');

  useEffect(() => {
    setSelectedShape(element?.shape || 'square');
    setColor(element?.style?.fill || '#ff0000');
  }, [element?.id]);

  const handleShapeChange = (newShape) => {
    setSelectedShape(newShape);
    onUpdate({
      shape: newShape,
      style: { ...element?.style, fill: color }
    });
  };

  const handleColorChange = (newColor) => {
    setColor(newColor);
    onUpdate({
      shape: selectedShape,
      style: { ...element?.style, fill: newColor }
    });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wide">Shape Properties</h3>

      {/* Shape Type */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-2">Shape Type</label>
        <select
          value={selectedShape}
          onChange={(e) => handleShapeChange(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        >
          {SHAPES.map(shape => (
            <option key={shape} value={shape}>
              {shape.charAt(0).toUpperCase() + shape.slice(1)}
            </option>
          ))}
        </select>
      </div>

      {/* Color */}
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-3">Color</label>
        <div className="w-full">
          <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm">
            <HexColorPicker 
              color={color} 
              onChange={handleColorChange}
              style={{ width: '100%', height: '200px' }}
            />
            <div className="mt-4 flex items-center gap-2">
              <span className="text-xs font-medium text-gray-600">HEX</span>
              <input
                type="text"
                value={color.toUpperCase()}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^#[0-9A-F]{6}$/i.test(val)) {
                    handleColorChange(val);
                  }
                }}
                className="flex-1 px-3 py-2 border border-gray-300 rounded text-xs font-mono focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="#ff0000"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
